import api from "./api";

async function getBranches() {
  try {
    const { data } = await api.get("/api/branches");
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.response?.data?.message || "Could not load branches" };
  }
}

async function submitTrainerApplication(payload) {
  try {
    const { data } = await api.post("/api/trainer-applications", payload);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.response?.data?.message || "Could not submit application" };
  }
}

export const branchService = {
  getBranches,
  submitTrainerApplication,
};
